module.exports = __webpack_public_path__ + "static/media/gamelets.anoxic.me.56b3db6e.png";